{
  "contactModal": {
    "delete": {
      "cancel": "取消",
      "confirm": "删除",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "您确定要删除此联系人吗？",
      "success": "success",
      "title": "删除联系人"
    }
  },
  "contacts": {
    "buttons": {
      "add": "添加联系人"
    },
    "table": {
      "headers": {
        "actions": "操作",
        "email": "邮箱",
        "id": "ID",
        "name": "姓名"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "取消",
      "delete": "删除",
      "save": "保存"
    },
    "createTitle": "新建生产站点",
    "delete": {
      "cancel": "取消",
      "confirm": "删除",
      "message": "您确定要删除此生产站点吗？",
      "title": "删除生产站点"
    },
    "editTitle": "编辑生产站点",
    "errors": {
      "cityRequired": "城市是必填的",
      "coordinatesMaxDecimals": "纬度和经度最多只能有 6 位小数",
      "countryMustBeValid": "国家必须是有效的 (例如 FR, DE)",
      "internalCodeTooLong": "内部代码必须少于 32 个字符",
      "nameRequired": "名称是必填的",
      "postalCodeTooShort": "邮编必须至少有 3 个字符",
      "streetRequired": "街道是必填的",
      "streetTooShort": "街道必须至少有 3 个字符"
    },
    "labels": {
      "city": "城市",
      "country": "国家",
      "internalCode": "内部代码",
      "latitude": "纬度",
      "longitude": "经度",
      "name": "生产站点名称",
      "performedActivities": "执行活动",
      "postalCode": "邮编",
      "registrationId": "设施注册编号",
      "street": "街道"
    },
    "placeholders": {
      "city": "例如：达卡",
      "country": "选择设施所在国家",
      "internalCode": "例如：BD-DAK-001或您的内部编号",
      "latitude": "例如：48.8566",
      "longitude": "例如：2.3522",
      "name": "例如：达卡裁剪缝制车间A",
      "performedActivities": "例如：裁剪、缝制、后整理、染色",
      "postalCode": "例如：1207",
      "registrationId": "例如：增值税号、CIN、GSTIN、USC",
      "street": "例如：贝克街221B号"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS：9 位数字。",
      "EORI": "EORI：国家代码 + 14 位数字。",
      "GLN": "GLN：13 位数字。",
      "OTHER": "其他：最多 32 个字符。",
      "RCS": "RCS：RCS + 空格 + 公司名称 + 空格 + [A,B] + 空格 + 9 位数字。",
      "VAT": "VAT：国家代码（如 FR）+ 2 位 + 9 位 SIREN 号。"
    },
    "registrationIdErrors": {
      "DUNS": "DUNS 注册 ID 须为 9 位数字。",
      "EORI": "EORI 注册 ID 格式须为：国家代码（如 FR）+ 14 位数字。",
      "GLN": "GLN 注册 ID 须为 13 位数字。",
      "OTHER": "其他注册 ID 须少于 32 个字符。",
      "RCS": "RCS 注册 ID 格式须为：RCS + 空格 + 公司名称 + 空格 + [A,B] + 空格 + 9 位数字。",
      "VAT": "VAT 注册 ID 格式须为：国家代码（如 FR）+ 2 位键 + 9 位 SIREN 号。"
    },
    "tabs": {
      "generalInfo": "基本信息",
      "location": "位置"
    },
    "tooltips": {
      "address": "地址",
      "city": "城市",
      "country": "国家",
      "internalCode": "内部代码",
      "latitude": "纬度",
      "longitude": "经度",
      "name": "名称",
      "performedActivities": "执行活动",
      "postalCode": "邮编",
      "registrationId": "设施注册编号",
      "street": "街道"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "添加生产站点"
    },
    "create": {
      "error": "添加生产站点时出错",
      "success": {
        "message": "生产站点已成功添加",
        "title": "生产站点添加成功"
      }
    },
    "delete": {
      "error": "删除生产站点时出错",
      "success": {
        "message": "生产站点已成功删除",
        "title": "生产站点删除成功"
      }
    },
    "filters": {
      "country": "国家",
      "internalCode": "内部代码",
      "isConfidential": "保密",
      "isConfidentialFalse": "否",
      "isConfidentialTrue": "是",
      "name": "生产站点名称",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "执行活动",
      "searchPlaceholder": "搜索过滤器",
      "title": "过滤器"
    },
    "search": {
      "placeholder": "搜索名称或地址"
    },
    "sorts": {
      "address": "地址",
      "country": "国家",
      "email": "邮箱",
      "internalCode": "内部代码",
      "name": "名称"
    },
    "table": {
      "headers": {
        "address": "地址",
        "certificates": "证书",
        "deleted": "已删除",
        "id": "ID",
        "internalCode": "内部代码",
        "name": "名称",
        "performedActivities": "执行活动",
        "registrationId": "设施注册编号"
      }
    },
    "title": "生产站点",
    "update": {
      "error": "更新生产站点时出错",
      "success": {
        "message": "生产站点已成功更新",
        "title": "生产站点更新成功"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "错误"
    }
  }
}
